import React from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';
import { API_BASE_URL } from '../config';


const crearBalance = ({ token, id_company }) => {
  const generarBalance = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/generar-balance`, {
        params: { id_company },
        headers: { Authorization: `Bearer ${token}` }
      });
      showSuccess(response.data); // Muestra el mensaje de éxito
    } catch (error) {
      console.error('Error al generar balance:', error);
      showError('Hubo un error al generar balance');
    }
  };

  return (
    <div>
      <h1>Balance General</h1>
      <button onClick={generarBalance}>Generar Balance General</button>
    </div>
  );
};

export default crearBalance;
